import React, { useState, useEffect } from 'react';
import { FaHandHoldingHeart, FaUsers, FaChartLine } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const DonationCounter = ({ onDonateClick }) => {
  const [count, setCount] = useState(0);
  const targetAmount = 5000;
  const navigate = useNavigate();
  useEffect(() => {
    const duration = 2000; // 2 seconds
    const steps = 50;
    const increment = targetAmount / steps;
    const interval = duration / steps;

    let currentStep = 0;
    const timer = setInterval(() => {
      currentStep++;
      setCount(Math.min(Math.round(increment * currentStep), targetAmount));
      
      if (currentStep >= steps) {
        clearInterval(timer);
      }
    }, interval);

    return () => clearInterval(timer);
  }, []);

  const handleDonateClick = () => {
    if (onDonateClick) {
      onDonateClick();
    }
    navigate('/donate');
  };

  return (
    <div className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-[#eecda3] to-[#6dd5ed]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-black mb-4">Our Impact</h2>
          <p className="text-xl text-black">Together, we're making a difference in our community</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Total Donations */}
          <div className="bg-white rounded-lg p-8 shadow-xl transform hover:scale-105 transition-transform duration-300">
            <div className="flex flex-col items-center">
              <FaHandHoldingHeart className="text-4xl text-blue-400 mb-4" />
              <h3 className="text-2xl font-bold text-black mb-2">Total Donations</h3>
              <div className="text-4xl font-bold text-blue-400">
                ${count.toLocaleString()}
              </div>
              <p className="text-gray-600 mt-2">Target: $5,000</p>
            </div>
          </div>

          {/* Lives Impacted */}
          <div className="bg-white rounded-lg p-8 shadow-xl transform hover:scale-105 transition-transform duration-300">
            <div className="flex flex-col items-center">
              <FaUsers className="text-4xl text-blue-400 mb-4" />
              <h3 className="text-2xl font-bold text-black mb-2">Lives Impacted</h3>
              <div className="text-4xl font-bold text-blue-400">
                {Math.round(count * 3)}
              </div>
              <p className="text-gray-600 mt-2">Each donation helps 3 people</p>
            </div>
          </div>

          {/* Growth Rate */}
          <div className="bg-white rounded-lg p-8 shadow-xl transform hover:scale-105 transition-transform duration-300">
            <div className="flex flex-col items-center">
              <FaChartLine className="text-4xl text-blue-400 mb-4" />
              <h3 className="text-2xl font-bold text-black mb-2">Monthly Growth</h3>
              <div className="text-4xl font-bold text-blue-400">
                +{Math.round(count / 10)}%
              </div>
              <p className="text-gray-600 mt-2">Compared to last month</p>
            </div>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="mt-12 bg-white rounded-lg p-8 shadow-xl">
          <h3 className="text-2xl font-bold text-black mb-4 text-center">Donation Progress</h3>
          <div className="w-full bg-gray-200 rounded-full h-6">
            <div 
              className="bg-blue-400 h-6 rounded-full transition-all duration-1000 ease-out"
              style={{ width: `${(count / targetAmount) * 100}%` }}
            ></div>
          </div>
          <div className="flex justify-between mt-2 text-sm text-gray-600">
            <span>0%</span>
            <span>50%</span>
            <span>100%</span>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <button 
            onClick={handleDonateClick}
            className="bg-blue-400 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-500 transition-colors duration-300 transform hover:scale-105"
          >
            Make a Donation
          </button>
          <p className="mt-4 text-black">
            Your contribution can save lives. Every donation counts!
          </p>
        </div>
      </div>
    </div>
  );
};

export default DonationCounter; 